import SectionHeading from "@/components/base/SectionHeading";

const testimonials = [
  {
    name: "一只团子",
    role: "猫妖爱好者",
    avatar: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20with%20ginger%20hair%20and%20cat%20ears%2C%20soft%20smile%2C%20warm%20cream%20background%2C%20kawaii%20webtoon%20style%2C%20round%20icon%2C%20high%20quality&width=200&height=200&seq=avatar-tuanzi&orientation=squarish",
    text: "想找某部妖精漫画女主的人设，翻半天找不到，在这站一搜就出来了。角色介绍写得很走心，萌娘属性标得也准。",
  },
  {
    name: "南山南",
    role: "狐面王妃粉丝",
    avatar: "https://readdy.ai/api/search-image?query=gentle%20anime%20girl%20avatar%20with%20black%20hair%20and%20warm%20eyes%2C%20soft%20smile%2C%20cream%20background%2C%20kawaii%20webtoon%20style%2C%20round%20icon%2C%20high%20quality&width=200&height=200&seq=avatar-nanshan&orientation=squarish",
    text: "CP组合整理得太懂我了！姜梦萝和玄渊那段写得我反复看，还顺藤摸瓜发现了好几个同好的冷门作品。",
  },
  {
    name: "糖分超标",
    role: "治愈系读者",
    avatar: "https://readdy.ai/api/search-image?query=cute%20anime%20girl%20avatar%20with%20pink%20hair%20and%20a%20big%20smile%20holding%20a%20sweet%20treat%2C%20warm%20cream%20background%2C%20kawaii%20webtoon%20style%2C%20round%20icon%2C%20high%20quality&width=200&height=200&seq=avatar-sugar&orientation=squarish",
    text: "跟着图鉴把几部治愈向妖精漫画都补完了，女主一个个都又美又让人心疼。图鉴更新很勤，体验很好。",
  },
  {
    name: "浮生若梦",
    role: "图鉴共建者",
    avatar: "https://readdy.ai/api/search-image?query=thoughtful%20anime%20girl%20avatar%20with%20long%20brown%20hair%2C%20soft%20gentle%20look%2C%20cream%20background%2C%20kawaii%20webtoon%20style%2C%20round%20icon%2C%20high%20quality&width=200&height=200&seq=avatar-dream&orientation=squarish",
    text: "我投稿了几个冷门女主资料，编辑审核很快，还帮我补了CP线。这种共建的氛围真的很难得。",
  },
];

export default function Testimonials() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <SectionHeading
        eyebrow="读者口碑"
        title="同好们都怎么说"
        desc="来自图鉴读者与共建者的真实反馈，也是我们持续更新的最大动力。"
        align="center"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((t, i) => (
          <figure key={t.name} className="reveal flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-1 text-accent-500" aria-label="五星好评">
              {Array.from({ length: 5 }).map((_, n) => (
                <i key={n} className="ri-star-fill text-sm" aria-hidden="true"></i>
              ))}
            </div>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">"{t.text}"</blockquote>
            <figcaption className="mt-4 flex items-center gap-3">
              <img src={t.avatar} alt={`${t.name} 头像`} className="h-10 w-10 rounded-full object-cover" />
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
            {i === 0 && <div className="sr-only">图鉴读者好评示例</div>}
          </figure>
        ))}
      </div>
    </section>
  );
}